import { render, staticRenderFns } from "./areaAdminProductList.vue?vue&type=template&id=2ff9b31d&scoped=true"
import script from "./areaAdminProductList.vue?vue&type=script&lang=js"
export * from "./areaAdminProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9b31d",
  null
  
)

export default component.exports